export const primary = "#282828"
export const secundary = "#fff"
export const backgroundColor = "#fff"
